import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { actSendProductsRequest, fetchProducts } from "../../actions";
import { getNotifyMe } from "../../Redux/ProductController/action";
import { createOrder } from "../../Redux/ProductController/action";
import Wishlist from "./WishlistHeart";
import { IoCheckmarkOutline } from "react-icons/io5";
import { MdClose } from "react-icons/md";
import { useToast } from "@chakra-ui/react";

function ProductCard(props) {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toast = useToast();

  const notifyMeHandler = (productId) => {
    dispatch(getNotifyMe(productId));
  };
  const {
    productId,
    productName,
    productImage,
    price,
    sellingPrice,
    discountPercentage,
    quantityAvailable,
    variantId,
    sourceMediaId,
  } = props;

  function closeAll() {
    toast.closeAll();
  }

  let name;

  if (productName.length > 20) {
    name = `${productName.slice(0, 20)}...`;
  } else {
    name = productName;
  }

  const handleProceedToCheckout = () => {
    dispatch(fetchProducts());

    const orderData = {
      orderType: "CART",
    };
    dispatch(createOrder(orderData));

    navigate("/Cart/PlaceOrder");
    closeAll();

    // if (myState.products) {
    //   if (myState.products.length > 0) {
    //     const orderData = {
    //       orderType: "CART",
    //     };
    //     dispatch(createOrder(orderData));
    //     if (orderList?.find((item) => item.productId === productId)) {
    //       orderList.push(orderData);
    //     }
    //     navigate("/Cart/PlaceOrder");
    //   }
    // }
  };

  const handleAddToCart = () => {
    if (token === null) {
      navigate("/authenticate");
      toast({
        title: "Please Login First",
        status: "success",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    } else {
      const cartData = {
        productId,
        variantId,
        quantity: 1,
      };

      // Dispatch actions if no error and the button text is not "Go to Cart"
      dispatch(actSendProductsRequest(cartData));

      toast({
        position: "top-right",
        render: () => (
          <div className="px-10 py-5 bg-white rounded-lg shadow-lg">
            <div className="flex justify-between items-center m-3">
              <div className="flex gap-3 items-center m-3">
                <IoCheckmarkOutline />
                <p>Item added to your cart</p>
              </div>
              <div
                className="h-3 w-3 cursor-pointer"
                onClick={() => {
                  closeAll();
                }}
              >
                <MdClose />
              </div>
            </div>
            <div className="flex gap-3 max-w-[300px] max-h-[300px]">
              <img
                src={productImage}
                alt={productName}
                className="w-16 rounded-md"
              />
              <p>{productName}</p>
            </div>
            <div>
              <button
                className="bg-transparent text-black font-semibold w-full py-3 border border-black hover:bg-gray-100 rounded my-3"
                onClick={() => {
                  navigate("/Cart/AddToCart");
                }}
              >
                View my Cart
              </button>
              <button
                className="bg-transparent text-black font-semibold w-full py-3 border border-black hover:bg-gray-100 rounded my-3"
                onClick={() => {
                  handleProceedToCheckout();
                }}
              >
                Checkout
              </button>
              <button
                className="bg-transparent underline text-black font-semibold w-full cursor-pointer"
                onClick={() => {
                  closeAll();
                }}
              >
                Continue Shopping
              </button>
            </div>
          </div>
        ),
        duration: 1000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <div className="max-w-sm mx-5 my-3 xl:max-w-md lg:m-3">
        <Link to={`/productDetails/${productId}`}>
          <div className="relative">
            {/* Wishlist */}
            {/* <Wishlist
              sourceMediaId={sourceMediaId}
              productId={productId}
              variantId={variantId}
            /> */}
            <div className="rounded-lg shadow-lg max-w-sm xl:max-w-md overflow-hidden">
              <img
                className="rounded-lg transition ease-in-out hover:scale-105 duration-300"
                src={productImage}
                alt={productName}
              />
            </div>
            <div className="py-2">
              <div className="flex justify-between items-center w-full text-left">
                <h1 className="py-1">{name}</h1>
                <div>
                  {quantityAvailable ? (
                    <button
                      className="bg-[#F52E7D] hover:bg-[#ee70a3] text-[13px] text-[white] py-1 px-2 rounded-md"
                      onClick={(e) => {
                        e.preventDefault();
                        toast({
                          title:
                            "We will notify you, when the product is available",
                          status: "success",
                          duration: 3000,
                          position: "top",
                          isClosable: true,
                        });
                        notifyMeHandler(productId);
                      }}
                    >
                      Notify Me
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="flex items-start w-full text-left justify-between py-1">
                <div className="flex gap-2">
                  <p className="line-through">₹{price}</p>
                  <p className="font-bold">₹{sellingPrice}</p>
                </div>
                {/* <div
                  className="flex justify-center items-center w-[2em] h-[2em] rounded-full bg-slate-300 hover:bg-slate-200"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <BsCart2 size={16} />
                </div> */}
              </div>
            </div>
            {quantityAvailable ? (
              <div className="absolute bg-[black] px-3 py-[3px] top-1 left-1 rounded-md">
                <p className="text-[13px] font-bold text-white">{"Sold Out"}</p>
              </div>
            ) : (
              <div className="absolute bg-[#1E9C99] px-3 py-[3px] top-1 left-1 rounded-md">
                <p className="text-[13px] font-bold text-white">{`${discountPercentage}% Off`}</p>
              </div>
            )}
          </div>
        </Link>

        <button
          onClick={() => {
            handleAddToCart();
          }}
          className={`bg-transparent ${
            quantityAvailable
              ? "text-gray-600 border-gray-600"
              : "text-black border-black hover:bg-gray-100"
          } font-semibold w-full py-3 border rounded my-3`}
          disabled={quantityAvailable ? true : false}
        >
          {quantityAvailable ? "Sold Out" : "Add to Cart"}
        </button>
      </div>
    </>
  );
}

export default ProductCard;
